import {
  Instance_default
} from "./chunk-K7Z5Y6B4.js";
import {
  BaseRoute_default
} from "./chunk-Q7RR6V45.js";

// src/Pim/PimProduct/PimProductRoute.ts
var PimProductRoute = class extends BaseRoute_default {
  constructor() {
    super(...arguments);
    this.option = "reditem-item_pim_product_59";
    this.getList = (filters) => {
      const buildFilters = this.createFilters(filters);
      return Instance_default.get(
        this.createRequestURL({
          option: this.option,
          ...buildFilters
        })
      );
    };
    this.createFilters = (filters) => {
      let buildFilter = {};
      for (const [key, value] of Object.entries(filters)) {
        if (typeof value === "object") {
          switch (value?.type) {
            case "custom_fields":
              buildFilter["filter[" + value.type + "][" + key + "][]"] = value.value;
              break;
            case "filter":
              buildFilter["filter[" + key + "]"] = value.value;
              break;
            default:
              break;
          }
        } else {
          buildFilter[key] = value;
        }
      }
      return buildFilter;
    };
    this.getDetail = (id = 0, dataFilter = {}) => {
      return Instance_default.get(
        this.createRequestURL({
          option: this.option,
          id,
          ...dataFilter
        })
      );
    };
    this.create = (data) => {
      return Instance_default.post(
        this.createRequestURL({
          option: this.option
        }),
        data
      );
    };
    this.update = (data) => {
      return Instance_default.put(
        this.createRequestURL({
          option: this.option
        }),
        data,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      );
    };
    this.delete = (id) => {
      return Instance_default.delete(
        this.createRequestURL({
          option: this.option
        }),
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: { id }
        }
      );
    };
    this.updateStatus = (listSelected) => {
      return Instance_default.post(
        this.createRequestURL({
          option: this.option,
          task: "bulkUpdate"
        }),
        {
          items: listSelected
        }
      );
    };
    this.deleteProducts = (listSelected) => {
      return Instance_default.post(
        this.createRequestURL({
          option: this.option,
          task: "bulkDelete"
        }),
        {
          items: listSelected
        }
      );
    };
  }
};
var PimProductRoute_default = PimProductRoute;

export {
  PimProductRoute_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
